<template>
  <div>
    <Head :title="__('Nouvelle configuration')" />

    <div class="mr-2 overflow-hidden bg-white rounded-md shadow">
      <div class="flex items-center justify-between px-8 py-4 border-b border-gray-100">
        <h2 class="text-lg font-semibold text-gray-800">{{ __('Nouvelle configuration') }}</h2>
      </div>

      <form @submit.prevent="submit" class="px-8 py-6 space-y-5">

        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">{{ __('Clé') }}</label>
          <input
            v-model="form.key"
            type="text"
            class="w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            :class="form.errors.key ? 'border-red-400' : 'border-gray-300'"
            placeholder="ex: ourvoice_api_key"
          />
          <p class="mt-1 text-xs text-gray-400">Lettres minuscules, chiffres et underscore uniquement.</p>
          <p v-if="form.errors.key" class="mt-1 text-xs text-red-500">{{ form.errors.key }}</p>
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">{{ __('Valeur') }}</label>
          <div class="relative">
            <input
              v-model="form.value"
              :type="showValue ? 'text' : 'password'"
              class="w-full px-3 py-2 pr-10 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              :class="form.errors.value ? 'border-red-400' : 'border-gray-300'"
              placeholder="••••••••••••"
            />
            <button type="button" @click="showValue = !showValue"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              <svg v-if="!showValue" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg v-else class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            </button>
          </div>
          <p v-if="form.errors.value" class="mt-1 text-xs text-red-500">{{ form.errors.value }}</p>
        </div>

        <div class="flex items-center justify-between pt-4 border-t border-gray-100">
          <Link :href="route('account.config')" class="text-sm text-gray-500 hover:text-gray-700">
            {{ __('Annuler') }}
          </Link>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('Enregistrer') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: { Head, Link, LoadingButton },
  layout: Layout,

  props: {
    account: Object,
  },

  setup() {
    const form = useForm({ key: '', value: '' })
    return { form }
  },

  data() {
    return { showValue: false }
  },

  methods: {
    submit() {
      this.form.post(this.route('account.config.store'))
    },
  },
}
</script>
